import { HTMLAttributes, useMemo } from "react";
import { CardHeader } from "./cards/header";

interface Props extends HTMLAttributes<HTMLElement> {
  tempWorker: any;
}

export const AvatarCandidate = ({ tempWorker }: Props) => {
  const chips = useMemo(() => {
    let chips: {
      label: string;
      color:
        | "default"
        | "primary"
        | "secondary"
        | "error"
        | "info"
        | "success"
        | "warning";
    }[] = [];

    if (tempWorker.available_at)
      chips.push({ label: "Disponible", color: "success" });
    if (tempWorker.in_mission)
      chips.push({ label: "En mission", color: "info" });
    if (Object.keys(tempWorker.changes).length > 0)
      chips.push({ label: "Changements", color: "error" });

    return chips;
  }, [tempWorker]);

  return (
    <CardHeader
      title={`${tempWorker.first_name} ${tempWorker.last_name}`}
      avatarSrc={tempWorker.avatar_url}
      avatarSubstitute={`${tempWorker.first_name[0].toUpperCase()}`}
      chips={chips}
    />
  );
};
